import React, { useEffect, useState } from 'react';
import DebateRoomNew from './DebateRoomNew';
import DebateRoomMobile from './DebateRoomMobile';
import DebateRoomTablet from './DebateRoomTablet';
import './DebateRoomRouter.css';

const DebateRoomRouter = () => {
  const [viewType, setViewType] = useState('mobile'); // 'mobile', 'tablet', 'desktop'
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Robust device detection with High-DPI tablet support
    const checkDevice = () => {
      // Get viewport dimensions
      const width = window.innerWidth;
      const height = window.innerHeight;
      const isPortrait = height > width;
      
      // Get device pixel ratio for High-DPI displays
      const dpr = window.devicePixelRatio || 1;
      const physicalWidth = width * dpr;
      const physicalHeight = height * dpr;
      
      // User agent detection
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isTabletUA = /iPad|Android(?!.*Mobile)/i.test(userAgent);
      const isMobileUA = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
      
      // Touch capability
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      
      // Screen detection with DPR consideration
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      
      let view = 'mobile';
      let deviceType = 'UNKNOWN';
      
      // Three-way detection: Phone → Mobile, Tablet → Tablet, Desktop → Desktop
      if (width < 600) {
        // Small screens = Phone → Mobile Component
        deviceType = 'PHONE';
        view = 'mobile';
      } else if (width >= 600 && width <= 1024) {
        // Medium screens = Tablet → Tablet Component
        deviceType = isTabletUA ? 'TABLET (UA)' : 'TABLET (size-based)';
        view = 'tablet';
      } else {
        // Large screens = Desktop → Desktop Component
        deviceType = 'DESKTOP';
        view = 'desktop';
      }
      
      // Optional: Log detection for debugging
      console.log('Device Detection:', {
        width,
        deviceType,
        view: view.toUpperCase() + ' VIEW'
      });
      
      setViewType(view);
      setIsLoading(false);
    };

    checkDevice();
    
    // Re-check on resize and orientation change with debounce
    let timeout;
    const debouncedCheck = () => {
      clearTimeout(timeout);
      timeout = setTimeout(checkDevice, 100);
    };
    
    window.addEventListener('resize', debouncedCheck);
    window.addEventListener('orientationchange', checkDevice);
    
    return () => {
      clearTimeout(timeout);
      window.removeEventListener('resize', debouncedCheck);
      window.removeEventListener('orientationchange', checkDevice);
    };
  }, []);

  if (isLoading) {
    return (
      <div style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#000',
        color: '#fff',
        fontSize: '18px'
      }}>
        Loading...
      </div>
    );
  }

  // Render the appropriate component
  const renderComponent = () => {
    switch(viewType) {
      case 'mobile':
        return <DebateRoomMobile />;
      case 'tablet':
        return <DebateRoomTablet />;
      case 'desktop':
        return <DebateRoomNew />;
      default:
        return <DebateRoomMobile />;
    }
  };

  return renderComponent();
};

export default DebateRoomRouter;
